module.exports = __webpack_public_path__ + "static/media/help.52440e20.svg";


//////////////////
// WEBPACK FOOTER
// ./src/resource/help.svg
// module id = 296
// module chunks = 0